import OneliveMypageProfileContent from './OneliveMypageProfileContent';
import OnelivePcMypageShell from './OnelivePcMypageShell';

/** 마이페이지 – 관리 헤더 + 메뉴 + 내역 콘텐츠 (/mypage/profile) */
export default function OneliveMobileProfilePage() {
  return (
    <OnelivePcMypageShell pageClassName="onelive-mobile-mypage-page">
      <OneliveMypageProfileContent />
    </OnelivePcMypageShell>
  );
}
